import * as React from "react"

import InstructionBox from './instructionBox'
import PromptStep from './promptStep'

import useFocus from '../../../Shared/hooks/useFocus'
import { orderedSteps, } from '../../helpers/containerActionHelpers'

const PromptStepContainer = ({
  activateStep,
  activityIsComplete,
  completionButtonCallback,
  completeStep,
  submitResponse,
  activities,
  session,
  activeStep,
  reportAProblem,
}) => {
  const { currentActivity, } = activities
  const { submittedResponses, hasReceivedData, } = session

  // the first step is reading, so we will always start at 2 and therefore want to begin at the 0 index
  const prompt = hasReceivedData && orderedSteps(activities)[activeStep - 2]
  const hasPrompt = !!prompt
  // A prompt's example starts open only until the student answers it, so it stays closed after a
  // submission, even when they come back to the prompt or reload the page.
  const answered = hasPrompt && !!submittedResponses?.[prompt.id]?.length
  const exampleKey = hasPrompt ? activeStep : null
  const [exampleOpen, setExampleOpen] = React.useState(!answered)
  const [exampleFor, setExampleFor] = React.useState(exampleKey)
  const [containerRef, setContainerFocus] = useFocus()
  if (exampleFor !== exampleKey) {
    setExampleFor(exampleKey)
    setExampleOpen(!answered)
  }

  // Every render has to call the same hooks, so they all sit above the early return. The container
  // only renders once there's a prompt, so that's when it takes focus.
  React.useEffect(() => {
    setContainerFocus()
  }, [hasPrompt])

  if (!prompt) return <span />;

  function handleToggleExample() {
    setExampleOpen(!exampleOpen)
  }

  function handleGetFeedback() {
    setExampleOpen(false)
  }

  return (
    <div className="prompt-steps no-focus-outline" ref={containerRef} tabIndex={-1}>
      <InstructionBox
        conjunction={prompt.conjunction}
        exampleOpen={exampleOpen}
        onToggleExample={handleToggleExample}
        tip={currentActivity.conjunction_specific_tip}
      />
      <PromptStep
        activateStep={activateStep}
        activityIsComplete={activityIsComplete}
        className="step active"
        completeStep={completeStep}
        completionButtonCallback={completionButtonCallback}
        currentActivity={currentActivity}
        key={activeStep}
        onGetFeedback={handleGetFeedback}
        prompt={prompt}
        reportAProblem={reportAProblem}
        stepNumber={activeStep}
        submitResponse={submitResponse}
        submittedResponses={(submittedResponses && submittedResponses[prompt.id]) || []}
      />
    </div>
  )
}

export default PromptStepContainer
